export enum StationsTemporalType {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  HOURLY = 'hourly'
}

export namespace StationsTemporalType {
  export function getApiType(type: StationsTemporalType) {
    switch (type) {
      case StationsTemporalType.DAILY:
        return 'DAILY'
      case StationsTemporalType.MONTHLY:
        return 'MONTHLY'
    }
  }
}
